import { render, staticRenderFns } from "./ArrivalGuest.vue?vue&type=template&id=b004ef16"
import script from "./ArrivalGuest.vue?vue&type=script&lang=js"
export * from "./ArrivalGuest.vue?vue&type=script&lang=js"
import style0 from "./ArrivalGuest.vue?vue&type=style&index=0&id=b004ef16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports